import React, { useState, useEffect } from "react";
import SearchModal from "../components/CreateEditModal/SearchModal";
import {
  Table,
  Button as But,
  Modal,
  Spin,
  notification,
  Form,
  Row,
  Col,
} from "antd";
import liracrypt from "../components/Liracrypt/liracrypt";
import CropDown from "../components/ReportFormGenerator/CropDown/CropDown";
import Button from "../components/ReportFormGenerator/Button/Button";
import Idame from "../components/ReportFormGenerator/Idame/Idame";
import Range from "../components/ReportFormGenerator/Range/Range";
import moment from "moment";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  LoadingOutlined,
  SolutionOutlined,
} from "@ant-design/icons";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SessionError from "../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import TrainingSessionCreateEditModal from "../components/CreateEditModal/TrainingSessionCreateEditModal";
import TypSubType from "../components/ReportFormGenerator/TypSubType/TypSubType";
import ZenTablePrime from "../components/PhantomZen/ZenTablePrime";
function TrainingSession({ setPageHeader }) {
  setPageHeader("Training Report");
  const [form] = Form.useForm();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalHeader, setModalHeader] = useState("");
  const [editData, setEditData] = useState(null);
  const [successButtonText, setSuccessButtonText] = useState("");

  const [requestType, setRequestType] = useState("GET");

  const [loadingDone, setLoadingDone] = useState(false);

  const [searchVisible, setSearchVisible] = useState(false);

  const [dataSource, setDataSource] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);

  const [actualDisabled, setActualDisabled] = useState([]);
  const [disabledList, setDisabledList] = useState([]);
  const [visibleIcon, setVisibleIcon] = useState([]);

  const [buttonLoading, setButtonLoading] = useState(false);

  const { confirm } = Modal;

  useEffect(() => {});

  const onFinish = (values) => {
    

    setLoadingDone(false);
    if (values["dt"]) {
      values["dt"] = values["dt"].format("YYYY/MM/DD");
    }
    if (values["assDt"]) {
      values["assDt"] = values["assDt"].format("YYYY/MM/DD");
    }
    if (requestType === "GET") {
      
      let [from, to] = values["range"];
      from = from.format("YYYY/MM/DD").toString();
      to = to.format("YYYY/MM/DD").toString();
      values["from"] = from;
      values["to"] = to;
      delete values["range"];
    }

    if (requestType === "GET") {
      setLoading(true);
      setButtonLoading(true);
      liracrypt
        .get("/training/log", values)
        .then((res, req) => {
          
          setDataSource(res.data);
          setActualDisabled(res.data.config ? res.data.config.readOnly : []);
          setVisibleIcon(res.data.config ? res.data.config.actionColumn : []);
          setLoading(false);
          setButtonLoading(false);
          setLoadingDone(true);
        })
        .catch((err) => {
          
          setLoading(false);
          setLoadingDone(true);
          setButtonLoading(false);
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else if (requestType === "CREATE") {
      setButtonLoading(true);
      values["act"] = "True";

      if (values["eame"]) {
      }

      // values["dt"] = values["dt"].format("YYYY/MM/DD").toString();
      // values["nxtDt"] = values["nxtDt"].format("YYYY/MM/DD").toString();

      liracrypt
        .post("/training/log", values)
        .then((res, req) => {
          if (res.data.isSuccess) {
            openNotificationWithIcon("success", "Document Inserted Successful");
            setRequestType("GET");
            setButtonLoading(false);
            // form.submit();
            // form.resetFields();
          } else {
            openNotificationWithIcon("error", "Document Insert Failed");
            setButtonLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setButtonLoading(false);
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else if (requestType === "EDIT") {
      // values["dt"] = values["dt"].format("YYYY/MM/DD").toString();
      // values["nxtDt"] = values["nxtDt"].format("YYYY/MM/DD").toString();
      // setButtonLoading(true);
      liracrypt
        .patch("/training/log", values)
        .then((res, req) => {
          if (res.data.isSuccess) {
            setModalVisible(false);
            openNotificationWithIcon("success", "Document Updated Successful");
            setRequestType("GET");
            form.submit();
          } else {
            openNotificationWithIcon("error", "Document Update Failed");
            // setButtonLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setButtonLoading(false);
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    }
  };

  const openNotificationWithIcon = (type, title, desc) => {
    notification[type]({
      message: title,
      description: desc ? desc : null,
    });
  };

  const CreateTraining = () => {
    setDisabledList([]);
    setSuccessButtonText("Create");
    setRequestType("CREATE");
    setModalHeader("Create Training Session");
    // form.resetFields();
    // setEditData(null);
    setModalVisible(true);
  };

  const DeleteData = (record) => {
    liracrypt
      .delete("/training/log", record)
      .then((res, req) => {
        if (res.data.isSuccess) {
          openNotificationWithIcon("warning", "Document Deleted Successful");
          form.submit();
        } else {
          openNotificationWithIcon("error", "Document Delete Successful");
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const EditModal = (text, record) => {
    return (
      <>
        <SessionError visible={loginError} />
        <div style={{ paddingTop: "5px", paddingBottom: "5px" }}>
          {visibleIcon.includes("edit") ? (
            <EditOutlined
              style={{
                marginRight: "20px",
                color: "#1890ff",
                fontSize: "25px",
              }}
              onClick={() => {
                
                
                setRequestType("EDIT");
                setModalHeader("Edit Training Session");
                setSuccessButtonText("Submit");
                setEditData(record);
                setModalVisible(true);
                setDisabledList(dataSource.config.readOnly["edit"]);
              }}
            />
          ) : (
            <></>
          )}
          {visibleIcon.includes("delete") ? (
            <DeleteOutlined
              onClick={() => {
                showDeleteConfirm(record);
                
              }}
              style={{
                color: "#ff4d4f",
                fontSize: "25px",
                marginRight: "20px",
              }}
            />
          ) : (
            <></>
          )}
          {visibleIcon.includes("view") ? (
            <EyeOutlined
              onClick={() => {
                setModalHeader("View Training Session");
                setSuccessButtonText("Ok");
                setEditData(record);
                setModalVisible(true);
                setDisabledList(dataSource.config.readOnly["view"]);
              }}
              style={{
                color: "#ffc53d",
                fontSize: "25px",
                marginRight: "20px",
              }}
            />
          ) : (
            <></>
          )}
          {visibleIcon.includes("approve") ? (
            <SolutionOutlined
              onClick={() => {
                setModalHeader("Approve Training Session");
                setSuccessButtonText("Submit");
                setEditData(record);
                setModalVisible(true);
                setDisabledList(dataSource.config.readOnly["approve"]);
              }}
              style={{ color: "#a0d911", fontSize: "25px" }}
            />
          ) : (
            <></>
          )}
        </div>
      </>
    );
  };

  function showDeleteConfirm(record) {
    confirm({
      title: (
        <h6
          style={{
            color: "#fff",
            margin: 0,
            marginTop: "1px",
            fontWeight: 600,
          }}
        >
          Are you sure delete ?
        </h6>
      ),
      icon: <ExclamationCircleOutlined />,
      okText: (
        <h6
          // onClick={() => DeleteData(record)}
          style={{
            margin: 0,
            color: "#ff4d4f",
            fontWeight: 600,
          }}
        >
          Yes
        </h6>
      ),
      onOk: () => DeleteData(record),
      cancelText: (
        <h6
          style={{
            margin: 0,
            color: "#fff",
            fontWeight: 600,
          }}
        >
          No
        </h6>
      ),
      cancelButtonProps: {
        ghost: true,
      },
      okButtonProps: {
        ghost: true,
        danger: true,
      },
    });
  }

  const editColumnData = [
    {
      title: "",
      width: "50px",
      render: (text, record) => EditModal(text, record),
    },
  ];

  const onFinishSearch = (values) => {};

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

  const TrainingModal = () => {
    return (
      <TrainingSessionCreateEditModal
        modalVisible={modalVisible}
        buttonLoading={buttonLoading}
        setModalVisible={setModalVisible}
        modalHeader={modalHeader}
        data={editData}
        form={form}
        onFinish={onFinish}
        successButtonText={successButtonText}
        resetButton={true}
        disabledList={disabledList}
        setRequestType={setRequestType}
      />
    );
  };

  const TableCompInt = () => {
    return (
      <>
        {!buttonLoading && dataSource ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <ZenTablePrime
              TblConfig={dataSource}
              editColumn={editColumnData}
            />
          </div>
        ) : (
          <>
            {/* <div className="Loading">
            <Spin indicator={antIcon} tip="Loading..." />
          </div> */}
          </>
        )}
      </>
    );
  };

  return (
    <>
      <SessionError visible={loginError} />

      <SearchModal
        modalHeader="Search"
        onFinish={onFinishSearch}
        successButtonText="Search"
        setModalVisible={setSearchVisible}
        modalVisible={searchVisible}
      />

      <TrainingModal />
      <div style={{ marginTop: "30px" }}></div>
      {/* 
    
      <div style={{ textAlign: "right" }}>
        <div
          style={{
            padding: "20px",
            textAlign: "right",
            display: "inline-block",
          }}
        >
          <But
            style={{ fontWeight: 600 }}
            type="primary"
            onClick={() => {setRequestType("CREATE");
            CreateTraining();setEditData(null)}}
          >
            Add New
          </But>
        </div>
        {/* <div style={{ textAlign: "right", display: "inline-block" }}>
          <But
            style={{ fontWeight: 600 }}
            type="danger"
            onClick={() => setSearchVisible(true)}
          >
            Search
          </But>
        </div> 
      </div> */}

      <div className="ThemeForm">
        <Form
          name="ReportForm"
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          layout="horizontal"
          colon={false}
          onFinish={(values) => {
            setRequestType("GET");
            onFinish(values);
          }}
          size="large"
        >
          <Row justify="center">
            <Col span={12}>
              <Range
                name="range"
                label="Period"
                defaultValue={[
                  moment().format("MMMM DD YYYY, h:mm:ss a"),
                  moment().format("MMMM DD YYYY, h:mm:ss a"),
                ]}
              />
            </Col>
          </Row>
          <Row justify="center">
            <Col span={12}>
              <Idame
                form={form}
                type="name"
                url="/mdict"
                urlData={{
                  typ: "Employee",
                  subTyp: "idame",
                  includeAll: true,
                }}
                idName="eid"
                nameName="eame"
                // disabled={disabledList.includes("prame")}
                nameLabel="Employee"
                defaultNameValue="All"
                defaultIdValue="All"
                nameErrorMessage="Please Select Employee"
                nameRequired={false}
                namePlaceholder="Select Employee"
              />
            </Col>
          </Row>
          <Row justify="center">
            <Col span={12}>
              <Idame
                form={form}
                type="name"
                url="/mdict"
                urlData={{
                  typ: "TrainingTypes",
                  subTyp: "idame",
                  includeAll: true,
                }}
                idName="trgSubjid"
                nameName="trgSubjName"
                // disabled={disabledList.includes("prame")}
                nameLabel="Training Subjects"
                defaultNameValue="All"
                defaultIdValue="All"
                nameErrorMessage="Please Select Training Subjects"
                nameRequired={false}
                namePlaceholder="Select Training Subjects"
              />
            </Col>
          </Row>
          <Row justify="center">
            <Col span={12}>
              <Idame
                form={form}
                type="name"
                url="/mdict"
                urlData={{
                  typ: "TrainingSessionsMdict",
                  subTyp: "idame",
                  includeAll: true,
                }}
                idName="trgSessid"
                nameName="trgSessName"
                // disabled={disabledList.includes("prame")}
                nameLabel="Training Sessions"
                defaultNameValue="All"
                defaultIdValue="All"
                nameErrorMessage="Please Select Training Sessions"
                nameRequired={false}
                namePlaceholder="Select Training Sessions"
              />
            </Col>
          </Row>

          <Row justify="center">
            <Col span={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "space-around",
                }}
              >
                <div>
                  <Button form={form} submitButtonText={"Search"} />
                </div>
                <div style={{ marginTop: "10px", marginLeft: "70px" }}>
                  <But
                    style={{
                      backgroundColor: "#2ecc71",
                      color: "#fff",
                      borderColor: "#2ecc71",
                    }}
                    className="login-form-button gx-mt-1 bigBtn"
                    onClick={() => {
                      setEditData(null);
                      CreateTraining();
                    }}
                  >
                    Add New
                  </But>
                  {/* <But
                style={{ fontWeight: 600 }}
                type="primary"
                onClick={() => {
                  setEditData(null);
                  CreateTraining();
                }}
              >
                Add New
              </But> */}
                </div>
              </div>
            </Col>
          </Row>
        </Form>
      </div>

      <TableCompInt />
    </>
  );
}

export default TrainingSession;
